import { useRef } from "react";
import { Button } from "./Button";

export interface SelectorArchivosProps {
  /** Nombre accesible del input (el botón muestra `textoBoton`). */
  etiqueta: string;
  textoBoton: string;
  accept: string;
  multiple?: boolean;
  deshabilitado?: boolean;
  onElegir: (archivos: File[]) => void;
}

/** Botón que abre el selector de archivos del sistema. No sube nada: entrega los archivos elegidos. */
export function SelectorArchivos({ etiqueta, textoBoton, accept, multiple = false, deshabilitado = false, onElegir }: SelectorArchivosProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        className="sr-only"
        aria-label={etiqueta}
        disabled={deshabilitado}
        onChange={(e) => {
          const archivos = Array.from(e.target.files ?? []);
          e.target.value = ""; // si no, el browser no dispara "change" al volver a elegir el mismo archivo
          if (archivos.length > 0) onElegir(archivos);
        }}
      />
      <Button type="button" variante="secundario" tamanio="sm" disabled={deshabilitado} onClick={() => inputRef.current?.click()}>
        {textoBoton}
      </Button>
    </>
  );
}
